import { BannerPlatform } from '@app/graphql/types/graphql';
import useStoreFrontBranch from '@app/page/online-order/banner/use-storefront_branch-query.ts';
import useTopBanners from '@app/page/online-order/banner/use-top-banner';
import { Box, Flex, Link, Stack, Text } from '@chakra-ui/react';
import { useEffect } from 'react';

interface TopBanner {
  id: string;
  title: string;
  description?: string | null;
  startTime: string;
  endTime: string;
  isActive: boolean;
  platforms: BannerPlatform[];
  backgroundColor: string;
}

interface TopBannersResponse {
  storefront_getAvailableTopBanner: TopBanner[];
}

export default function TopBanner(props: { branchID: string | null; platform: BannerPlatform }) {
  const branchID = props.branchID;

  // Fetch branch data
  const { data: branchData, error: branchError, loading: branchLoading } = useStoreFrontBranch(branchID ?? '');
  const companyId = branchData?.storefront_branch?.companyId;

  // Fetch banners data
  const {
    data: topBannersData,
    error: bannersError,
    loading: bannersLoading,
  } = useTopBanners(companyId ?? '', { platforms: props.platform });

  // Handle loading and error states
  useEffect(() => {
    if (branchLoading || bannersLoading) return;
    if (branchError ?? bannersError) return;
  }, [branchLoading, bannersLoading, branchError, bannersError]);

  if (branchLoading || bannersLoading) return null;
  if (branchError) return <Text>Error loading branch data: {branchError.message}</Text>;
  if (bannersError) return <Text>Error loading banners data: {bannersError.message}</Text>;

  const banners = (topBannersData as TopBannersResponse | undefined)?.storefront_getAvailableTopBanner ?? [];

  if (banners.length === 0) return null;

  return (
    <Stack className="top-banner" gap={0} divideY={'2px'}>
      {banners.map((banner) => {
        const backgroundColor = banner.backgroundColor;
        const textColor = 'white';

        return (
          <Box className="top-banner__item" px={2} key={banner.id} position="relative" bg={backgroundColor} py={3} width="full" borderRadius="xs">
            <Flex className="top-banner__content" alignItems={{ base: 'start', lg: 'center' }} justify={{ base: 'start', lg: 'center' }} gap={6}>
              <Text className="top-banner__text" fontSize="sm" color={textColor}>
                <Link href="#" _hover={{ textDecoration: 'none' }}>
                  <Flex
                    className="top-banner__message"
                    direction={{ base: 'column', lg: 'row' }}
                    align={{ base: 'start', lg: 'center' }}
                    justify={{ base: 'start', lg: 'center' }}
                    gapX={4}
                  >
                    <Text className="top-banner__title" fontWeight="semibold" letterSpacing="wide" textAlign="start">
                      {banner.title}
                    </Text>
                    <Text className="top-banner__description" fontWeight="medium" letterSpacing="wide" textAlign="start">
                      {banner.description}
                    </Text>
                  </Flex>
                </Link>
              </Text>
            </Flex>
          </Box>
        );
      })}
    </Stack>
  );
}
